
import { defineComponent, computed, onUpdated } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import PaperbackLogo from '@/common/components/ui/PaperbackLogo.vue'
import ColorModeSwitcher from '@/common/components/ui/ColorModeSwitcher.vue'
import { appRouteNames } from '@/router'
import { signUpLink } from '@/services/auth/config'

export default defineComponent({
    name: 'Welcome',
    components: {
        PaperbackLogo,
        ColorModeSwitcher,
    },
    setup() {
        const store = useStore()
        const oidcIsAuthenticated = computed(
            () => store.getters['auth/oidcIsAuthenticated']
        )
        const authenticateOidcPopup = () =>
            store.dispatch('auth/authenticateOidcPopup')
        const authenticateOidc = () => store.dispatch('auth/authenticateOidc')

        const colorMode = computed(() => store.getters['ui/colorMode'])

        onUpdated(() => {
            const router = useRouter()
            if (oidcIsAuthenticated.value) {
                router.push({ name: appRouteNames.SETTINGS })
            }
        })

        return {
            colorMode,
            oidcIsAuthenticated,
            authenticateOidcPopup,
            authenticateOidc,
            signUpLink,
        }
    },
})
